module.exports = __webpack_public_path__ + "static/media/kanye.92e02c3b.jpg";